import React from 'react'
import ReactDOM from 'react-dom'
import FieldErrors from './FieldErrors'
import { v4 as uuidv4 } from 'uuid'
import axios from 'axios'

class FilesUploader extends React.Component {
  constructor(props){
    super(props)

    this.state = {
      uploadingFiles: []
    }

    this.handleChange = this.handleChange.bind(this)
    this.removeFile = this.removeFile.bind(this)
    this.uploadFile = this.uploadFile.bind(this)
    this.updateFile = this.updateFile.bind(this)
  }

  removeFile(file) {
    const files = this.props.files.filter((img) => file.id != img.id )
    this.props.setData({files: files})
  }

  updateFile(file, newData) {
    const files = [...this.props.files]

    files[index] = file
    this.props.setData({files: files})
  }

  uploadFile(file) {
    const data = new FormData()
    const url = this.props.uploadUrl

    data.append('file', file.file)
    axios.post(url, data).then((resp) => {
      const uploadingFiles = this.state.uploadingFiles.filter((img) => file.id != img.id)
      this.setState({uploadingFiles: uploadingFiles})
      this.props.setData({files: this.props.files.concat(resp.data.file)})
    }).catch((resp) => {
      alert("There was an error uploading your file please try again.")
    })
  }

  handleChange(event) {
    const newFile = {id: uuidv4(), file: event.target.files[0], url: URL.createObjectURL(newFile)}
    const files = [...this.state.uploadingFiles, newFile]
    this.setState({uploadingFiles: files})
    this.uploadFile(newFile)
  }

  render() {
    const colClass = "file-uploader-size"

    return (
      <div className="d-flex justify-content-start align-content-start flex-wrap">
        {this.props.files.map((file) =>
          <div key={file.url} className="file-uploader__front remove file-uploader__cover" onClick={(e) => this.removeFile(file)}>
            <span>
              <i className="fa fa-times"></i>
              <span>Remove</span>
            </span>
          </div>
        )}
        {this.state.uploadingFiles.map((file) =>
          <div className={colClass} key={file.id}>
            <div className="remove" onClick={(e) => this.removeUploadingFile(file)}>
              Uploading
            </div>
          </div>
        )}

        <div className="custom-file">
          <input type="file" className="custom-file-input" id="customFile" />
          <label className="custom-file-label" htmlFor="customFile">Choose file</label>
        </div>
      </div>
    );
  }
}

export default FilesUploader
